<template>
    <div>
        <div class="main-container hidden-sm-and-down">
            <div class="container">
            <div class="auth" v-for="(item,index) in aboutlist" :key="index">
                 <h4>{{ item.brand_title_cate }}</h4>
                 <div class="thumb-example">
                     <div class="bannercontainer" ref="imgbox">
                         <div class="lbt">
                            <div class="carouser">
                                <el-carousel :interval="50000" arrow="never" ref="cardShow">
                                    <el-carousel-item v-for="(items,index) in  item.children" :key="index" ref="imgheight">
                                        <img class="lbtimg" ref="bannerHeight" :src="imgsrc + items.cover" alt="" />
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                            <p>
                                {{ item.brand_title_cate == '品牌荣誉' ? '企业备案号许可' : item.brand_title_cate }}证
                            </p>
                            
                         </div>
                            <div class="rightArrow">
                            <img src="../assets/icon-left.png" @click="arrowClick('right',index)" />
                        </div>
                        <div class="leftArrow">
                            <img src="../assets/icon-rig.png" @click="arrowClick('left',index)" />
                        </div>
                        <div class="swiper_rig">
                            <swiper ref="mySwiper" :options="swiperOptions">
                                <swiper-slide class="autolist"  v-for="(items, index) in item.children" :key="index">
                                    <div class="imgbox">
                                        <img ref="imgs" class="img" :src="imgsrc + items.cover" alt="">
                                        <p>&nbsp;</p>
                                    </div>
                                </swiper-slide>
                                <div ref="scrollbar" class="swiper-scrollbar" slot="scrollbar"></div>
                            </swiper>
                        </div>
                     </div>
                     
                 </div>
            </div>
        </div>
        </div>

        <div class="hidden-md-and-up">
            <div class="containermob" v-for="(item,index) in aboutlist" :key="index">
                <p>{{ item.brand_title_cate }}</p>
                <div>
                    <swiper class="moswiper" ref="mySwipertwo" :options="mySwipertwo">
                        <swiper-slide class="containerslide"  v-for="(items, index) in item.children" :key="index">
                               <div>
                                    <img @click="handle(items)"  ref="img" class="img" :src="imgsrc + items.cover" alt="">
                               </div>
                           
                        </swiper-slide>
                        <div class="swiper-pagination" slot="pagination"></div>
                    </swiper>
                    
                </div>
            </div>
                 <div v-if="imghid" class="imghid" @click="imghid = false">
                    <img :src="imgsrc + brandimg" alt="">
                </div>
            <div style="height:2rem"></div>
        </div>
    </div>
</template>

<script>
import { authority_url } from '../request/api'
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
    name: 'NewLiuyanShopWebBrandAuthority',
      components: {
    swiper,
    swiperSlide,
  },
    directives: {  },
    data() {
        return {
             aboutlist:[],
             bannerHeight:'',
             brandimg:'',
             imghid:false,
             swiperOptions: {
                    slidesPerView: 3, 
                    slidesPerGroup: 3,
                    scrollbar: {
                    el: ".swiper-scrollbar",
                    draggable: true,
                },
            },
            mySwipertwo:{
                pagination: {
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 2, 
                    slidesPerGroup: 2,
                    // loop : true,
                    // autoplay: {
                    //     delay: 3000,
                    // },
            }
         
        };
    },

    mounted() {
        authority_url().then((res)=>{
            this.aboutlist = res.data.data
            console.log(this.aboutlist)

        })

    },
    updated(){
        for (let j = 0; j < document.getElementsByClassName('swiper_rig').length; j++) {
            if(j){
                const element =  document.getElementsByClassName('swiper_rig')[j].getElementsByClassName('img')
                for (let i = 0; i < element.length; i++) {
                    const ele = element[i];
                    ele.style.width = '60%'
                }
            }
        }
        for (let j = 0; j < document.getElementsByClassName('auth').length; j++) {
        if(j){
            const element = document.getElementsByClassName('auth')[j].getElementsByClassName('carouser')
            for (let i = 0; i < element.length; i++) {
                const ele = element[i];
                ele.style.width = '41%'
            }
        }
    }
    },
  computed: {
   swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
    methods: {
        arrowClick(val,id) {
            val === "right" ?   this.$refs.cardShow[id].next() :  this.$refs.cardShow[id].prev();
        },
        handle(item){
            this.brandimg = item.cover
            this.imghid = true
        }
    },
};
</script>

<style lang="less" scoped>
.container{
     width: 100%;
    // min-height:calc(100vh - 300px);
     .auth:last-child{
         padding-bottom: 10%;
    }
    .auth{
        width: 80%;
        margin: 0 auto;
        text-align: left;
          h4{
            font-size: 35px;
            font-weight: 600;
            color: #00383F;
            line-height: 32px;
            border-bottom: 1px solid  rgba(0, 56, 63, 0.5);
            padding-bottom: 1.3%;
            padding-top: 6%;
        }
        .thumb-example{
            width: 100%;
            position: relative;
            padding-top: 20%;
               
            .bannercontainer{
                width: 100%;
                height: 488px;
                 background: url(../../static/autobg.png) no-repeat center center/100% 100%;
                 position: relative;
                .lbt{
                    width: 41%;
                    max-width: 600px;
                    padding-bottom: 5%;
                    background: #fff;
                    position: absolute;
                    bottom: 60px;
                    left: 44px;
                    .lbtimg{
                        width: 100%;
                    }
                    .carouser{
                        width: 78%;
                        margin: 12% auto;
                    }
                     p{
                        font-size:0.36rem;
                        font-weight: 400;
                        color: #00383F;
                        line-height: 32px;
                        text-align: center;
                    }
                }
                .swiper_rig{
                    width: 51%;
                    position: absolute;
                    right: 2%;
                    top: 18%;
                    height: 400px;
                    .imgbox{
                        width: 80%;
                    min-height: 200px;
                    height: 370px;  
                    display: table-cell; //主要是这个属性
                    vertical-align: middle;
                    text-align: center;
                    img{
                        width: 88.3%;
                        height: auto;
                    
                    }
                    }
                    img{
                        width: 230px;
                    }
                }
                .leftArrow {
                    width: 50px;
                    height: 50px;
                    position: absolute;
                    right: 50%;
                    top: -22%;
                    img{
                    width: 100%;
                    }
                }
                .rightArrow {
                    width: 50px;
                    height: 50px;
                    position: absolute;
                    right: 45%;
                    top: -22%;
                    img{
                    width: 100%;
                    }
                }
            }
        }
    }
    
    
}
/deep/.swiper-scrollbar-drag{
    background: #fff;
}
/deep/.swiper-scrollbar{
    background: #000;
}
/deep/.el-carousel__indicators--horizontal{
    display: none;
}
/deep/.swiper-container-horizontal > .swiper-scrollbar{
    width: 78%!important;
    left: 10%!important;
}
/deep/.el-carousel__container{
  min-height: 329px;
}
 @media (max-width: 991px) {
           .imghid{
                width: 100%;
                height: 100%;
                position: fixed;
                top: 0;
                z-index: 11;
                background-color: rgb(0 0 0 / 44%);
                z-index: 9999999;
                display: flex;
                align-items: center;
             img{
                 max-width: 95%;
                 max-height: 95%;
                 margin: 0 auto;
             }
         }
     .containermob{
         border-bottom: 1px solid rgba(0, 56, 63, 0.5);
         margin: 0 0.15rem;
   
         p{
             padding: 0.6rem 0 0.5rem 0;
             font-size: 0.36rem;
            font-weight: bold;
         }
         .moswiper{
             width: 6.08rem!important;
             height: 2.5rem;
              .containerslide{
                width: 2.9rem!important;
                height: 2rem!important;
                background: url(../../static/mobile/bannerbg.png) no-repeat!important;
                background-size: 100% 100% !important;
                margin-right: 0.01rem!important;
                 margin:0 0.132rem;
                    img{        
                        width: 1.75rem;
                        height: 1.23rem;
                        padding-top: 0.35rem;
                    }
            }
          .containerslide:nth-child(1){
             margin:0;
                    }
                /deep/.swiper-pagination{
                    bottom: 0.1rem;
                }
                /deep/.swiper-pagination-bullet{
                    background: #DADADA;
                    opacity:unset
                }
                /deep/.swiper-pagination-bullet-active{
                    background:#00383F;
                }
                    
            }   
        
        }
            .containermob:nth-child(2){
                .moswiper{
                width: 6.08rem!important;
                height: 4rem;
                .containerslide{
                    height: 3.499rem!important;
                    img{
                            width: 1.56rem;
                            height: 2.04rem;
                            padding-top: 0.78rem;
                        }
                }
            }   
        }
        .containermob:nth-child(3){
            .moswiper{
                width: 6.08rem!important;
                height: 4rem;
                .containerslide{
                    height: 3.499rem!important;
                    img{
                        width: 1.56rem;
                        height: 2.04rem;
                        padding-top: 0.78rem;
                    }
                }
        }   
        }
 }
</style>


// WEBPACK FOOTER //
// src/view/Brand_authority.vue